<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.91304 10.0668V11.5743C6.91353 11.8006 6.99966 12.0181 7.15348 12.1811C7.30731 12.3439 7.51681 12.4396 7.7382 12.4482C7.95948 12.4568 8.17553 12.3774 8.34088 12.2267L10.9826 9.81252C11.2082 9.6058 11.3371 9.31065 11.3371 9.00091C11.3371 8.69113 11.2082 8.39611 10.9826 8.18941L8.34088 5.77338C8.17553 5.62271 7.95948 5.54335 7.7382 5.5519C7.51681 5.56046 7.3073 5.65619 7.15348 5.81902C6.99966 5.98196 6.91353 6.19946 6.91304 6.42578V7.93333H3V3.13333C3 2.56762 3.21982 2.02495 3.6113 1.62489C4.00267 1.22473 4.53338 1 5.08696 1H12.913C13.4666 1 13.9973 1.2247 14.3887 1.62489C14.7802 2.02495 15 2.56759 15 3.13333V14.8667C15 15.4324 14.7802 15.975 14.3887 16.3751C13.9973 16.7753 13.4666 17 12.913 17H5.08696C4.53342 17 4.00267 16.7753 3.6113 16.3751C3.21984 15.975 3 15.4324 3 14.8667V10.0667L6.91304 10.0668Z"
    />
  </svg>
</template>
